module.exports = __webpack_public_path__ + "static/logo-15283cbf027c79ab32e58a0f5e32527e.png";